/**
 * Define namespace
 *
 */
var Intesa = Intesa || {};

/**
 * Intesa formsPBZ
 *
 */
Intesa.FormsPBZ = function () {
	
	this.score1 = 0;
	this.score2 = 0;
	
	var sessionScore1 = sessionStorage.getItem('score1') || '';
	if (sessionScore1.length > 0) {
		var JSON_score1 = parseInt(JSON.parse(sessionScore1));
		this.score1 = JSON_score1;
	}
	var sessionScore2 = sessionStorage.getItem('score2') || '';
	if (sessionScore2.length > 0) {
		var JSON_score2 = parseInt(JSON.parse(sessionScore2));
		this.score2 = JSON_score2;
	}

	function recaptchaCallback() {
		$("#recaptchainput").val('true');
		setTimeout(function () {
			$('form[name="formThanksMortgage"]').parsley().validate();
			formsPBZ.checkPrivacy();
		}, 500);
	}

	function validationCallback() {
		setTimeout(function () {
			$('form[name="formThanksMortgage"]').parsley().validate();
			forms.checkPrivacy();
		}, 500);
	}

	var myForm = $('input[name="myForm"]').val();
	var isPBZ = $('html').attr('data-bank') == 'PBZ';
	var isCIB = $('html').attr('data-bank') == 'CIB';
	var isSLO = $('html').attr('data-bank') == 'ISPSLOVENIA';

	/**
	 * Local variables
	 *
	 */
	var formsPBZ = this;

	/**
	 * Init component
	 *
	 */
	this.init = function () {

		if ((isCIB || isSLO) && !isPBZ) {
			window.intesa.formsPBZ = null;
			return; 
		}

		window.recaptchaCallback = $("input[name='recaptchaKey']").length >= 1 ? validationCallback : recaptchaCallback;

		formsPBZ.sessionMortgage = [{
			"form1": {
				"basicQuestionsOne": "",
				"basicQuestionsTwo": "",
				"permanentAddress": "",
				"codebtor": "",
				"account": "",
				"employment": "",
				"sameEmployer": "",
			}, "form2": {
				"averageSalary": "",
				"debitors": "0",
				"debitorIncomeOne": "",
				"debitorIncomeTwo": "",
				"existingLoan": "",
				"monthlyObligations": "",
				"revolvingCard": "",
				"maxCardLimit": "",
				"overdraft": "",
				"overdraftLimit": "",
			}, "form3": {
				"valueOfProperty": ""
			},
			"score": "",
		}];


		var sessionJSON = sessionStorage.getItem('mortgageJSON') || '';
		if (sessionJSON.length > 0) {
			var JSON_Obj = JSON.parse(sessionJSON);
			formsPBZ.sessionMortgage = JSON_Obj;
		}

		//formsPBZ.showModal();
		// formsPBZ.callServletTrigger();
		
		formsPBZ.setProductName();

		if ($('[data-component-r="formStep1Mortagage"]').length > 0 || $('[data-component-r="formStep2Mortagage"]').length > 0 || $('[data-component-r="formStep3Mortagage"]').length > 0 || $('[data-component-r="survey_loan"]').length > 0) {
			formsPBZ.refreshStep(1);
			formsPBZ.toggleAccordion();
			formsPBZ.formStep1Mortagage();
			if (sessionStorage.getItem('back') != 'true') {
				$('.rstep1').removeClass('rhide');
			}
			formsPBZ.setActiveInput();
			formsPBZ.setActiveImport();
			//formsPBZ.stepByStorage();
			formsPBZ.goToNext();
			formsPBZ.goBackStep();
			formsPBZ.plusMinus();
			if ($("#privacystatus").length > 0) {
				formsPBZ.checkPrivacy();
			}
			formsPBZ.initStep();
			formsPBZ.writeInput();
			
			// formsPBZ.checkMobileOrDesktopQuestionOne();
		}



	};

	/* --------------------- */
	
	
	this.setProductName = function(){
		var productName = formsPBZ.sessionMortgage[0]['form1']['productName'];
		if(productName != null ){
			var arr = productName.split(" ");
	
			for (var i = 0; i < arr.length; i++) {
			    arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
			}
	
			var finalProductName = arr.join(" ");
			
			if ($(".productName").length > 0) {
				$(".productName").each(function () {
					var thistitle = $(this).html();
					thistitle = thistitle.replace("${productName}", finalProductName);
					$(this).html(thistitle);
				})
			}
		}
	}
	
	
	
	this.checkMobileOrDesktopQuestionOne = function (){
		var step = formsPBZ.getStep();
		var dataStepNew = parseInt(step);
		var myForm = $('input[name="myForm"]').val();
		
		if(myForm == 'form1' && dataStepNew == 1){
			$('#submit').addClass('mobileVersion');
			$('#previous').addClass('desktopVersion');
		}
		else{
			$('#submit').removeClass('mobileVersion');
			$('#previous').removeClass('desktopVersion');
		}
	}
	
	
	
	this.freeEmptyField = function () {
		var step = formsPBZ.getStep();
		var dataStepNew = parseInt(step);
		var myForm = $('input[name="myForm"]').val();
		
		$(".rstepwrapper").eq(dataStepNew - 1).find('input:hidden').each(function (idx) {
			var name = this['name'];
			var type = this['type'];
			if(formsPBZ.sessionMortgage[0][myForm][name]){
				formsPBZ.sessionMortgage[0][myForm][name] = '';
			}
			if(type == 'radio'){
				$(".rstepwrapper").eq(dataStepNew - 1).find('input:hidden').eq(idx).parent().removeClass('active');
				this['checked'] = false;
			}
			else{
				this['value'] = '';
			}
		});
	}
	
	
	
	this.setNextActiveCheckingFields = function (step) {
		var compiled = true;
		var dataStepNew = parseInt(step);
		
		$(".rstepwrapper").eq(dataStepNew - 1).find('input:visible').each(function () {
			var type = this['type'];
			if(type == 'radio'){
				var name = this['name'];
				if($(".rstepwrapper").eq(dataStepNew - 1).find("input[name=" + name + "]:checked").length == 0){
					compiled = false;
				}
			}
			else{
				if(this['value'] == "" || this['value'] == null ||this['value'] == undefined){
					compiled = false;
				}
			}
		});
		
		if(compiled){
			formsPBZ.setActiveNext($('button.r-btn-next'));
		}
		else{
			formsPBZ.disableNext($('button.r-btn-next'));
		}
	}
	
	
	
	this.scoreFunction = function () {
		var myForm = $('input[name="myForm"]').val();
		var dataStepNew = formsPBZ.getStep() - 1;
		if(myForm == 'form1' && dataStepNew == 2){
			formsPBZ.score1 = parseInt($(".rstepwrapper").eq(dataStepNew - 1).find('input:checked').attr('js-data-score'));
			sessionStorage.setItem('score1', JSON.stringify(formsPBZ.score1));
		}
		
		if(myForm == 'form2' && dataStepNew == 1){
			var value = parseInt($(".rstepwrapper").eq(dataStepNew - 1).find('.js-data-score').val().replace(/[^0-9]/g, ''));
			if(value >= 1400 ){
				formsPBZ.score2 = 3;
			}
			if(value >= 1000 && value < 1400){
				formsPBZ.score2 = 2;
			}
			if(value < 1000 ){
				formsPBZ.score2 = 1;
			}
			sessionStorage.setItem('score2', JSON.stringify(formsPBZ.score2));
		}
		
		var sessionStorageMortgage = sessionStorage.getItem('mortgageJSON');
		var JSON_Obj = sessionStorageMortgage ? JSON.parse(sessionStorageMortgage) : {};
		JSON_Obj[0].score = formsPBZ.score1 + formsPBZ.score2;
		sessionStorage.setItem('mortgageJSON', JSON.stringify(JSON_Obj));
	} 
	
	
	
	this.writeInput = function () {
		var arrInput = Array.from($('.control-input-mortgage'))
		var sessionJSON = sessionStorage.getItem('mortgageJSON') || '';
		var myForm = $('input[name="myForm"]').val();
		var JSON_Obj = sessionJSON ? JSON.parse(sessionJSON) : {};
		
		if (JSON_Obj && JSON_Obj[0]){
			arrInput.forEach(function (input) {
				var name = input.name;
				if(JSON_Obj[0][myForm][name]['length'] > 0){
					if(name == 'debitorIncomeOne'){
						$("[data-plus]").click();
						$(".mod-hom1").eq(1).removeClass("rhide");
					}
					else if(name == 'debitorIncomeTwo'){
						$("[data-plus]").click();
						$(".mod-hom1").eq(2).removeClass("rhide");
					}
					if (input['type'] == "radio") {
						if(input['name'] == name && input['value'] == JSON_Obj[0][myForm][name]){
							input.click();
						}
					}
					else{
						input['value'] = JSON_Obj[0][myForm][name];
					}
				}
			})
		}
		
		if(sessionStorage.getItem('next')) {
			var step = formsPBZ.getStep();
			formsPBZ.setNextActiveCheckingFields(step);
		}
		
		if(sessionStorage.getItem('back')) {
			formsPBZ.setActiveNext($('button.r-btn-next'));
		}
	}
	
	
	
	this.initStep = function () {
		var sessionJSON = sessionStorage.getItem('mortgageJSON') || '';
		var myForm = $('input[name="myForm"]').val();
		
		if (sessionStorage.getItem('back') == 'true') {
			if (myForm == 'form1') {
				$('.rstepwrapper').addClass('rhide');
				$('.rstep6').removeClass('rhide');
				dataNewStep = 6;
			}
			if (myForm == 'form2') {
				$('.rstepwrapper').addClass('rhide');
				$('.rstep5').removeClass('rhide');
				dataNewStep = 5;
			}
			/*if (myForm == 'form3') {
				$('.rstepwrapper').addClass('rhide');
				$('.rstep1').removeClass('rhide');
				dataNewStep = 1;
			}*/
			
			window.intesa.formsPBZ.setStep(dataNewStep);
			window.intesa.formsPBZ.refreshStep(dataNewStep);
			
		}
		if (sessionStorage.getItem('next') == 'true') {
			$('.rstepwrapper').addClass('rhide');
			$('.rstep1').removeClass('rhide');
			dataNewStep = 1;
			
			window.intesa.formsPBZ.setStep(dataNewStep);
			window.intesa.formsPBZ.refreshStep(dataNewStep);
		}
	}
	
	

	this.stepByStorage = function () {
		var sessionJSON = sessionStorage.getItem('mortgageJSON') || '';
		if (sessionJSON.length > 0) {
			var JSON_Obj = JSON.parse(sessionJSON);

			if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form1) {
				for (var key in JSON_Obj[0].form1) {
					if ($('input[name="' + key + '"]').length > 0 && JSON_Obj[0].form1[key].length > 0 && sessionStorage.getItem('next') != 'true') {
						showStep(key);
						$('input[name="' + key + '"]').each(function () {
							var self = this;
							if ($(self).val() == JSON_Obj[0].form1[key]) {
								$(self).attr('checked', true).parent('label').trigger('click');
							}
						});

						switch (key) {
							case "basicQuestionsOne":
								formsPBZ.setStep(1);
								formsPBZ.refreshStep(1);
								$('.rstep1').removeClass('rhide');
								break;
							case "basicQuestionsTwo":
								formsPBZ.setStep(2);
								formsPBZ.refreshStep(2);
								$('.rstep2').removeClass('rhide');
								break;
							case "permanentAddress":
								formsPBZ.setStep(3);
								formsPBZ.refreshStep(3);
								$('.rstep3').removeClass('rhide');
								break;
							case "codebtor":
								formsPBZ.setStep(4);
								formsPBZ.refreshStep(4);
								$('.rstep4').removeClass('rhide');
								break;
							case "account":
								formsPBZ.setStep(5);
								formsPBZ.refreshStep(5);
								$('.rstep5').removeClass('rhide');
								break;
							case "employment":
								formsPBZ.setStep(6);
								formsPBZ.refreshStep(6);
								$('.rstep6').removeClass('rhide');
								break;
							default:
								break;
						}
					}
				}
			}

			if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form2) {
				for (var key in JSON_Obj[0].form2) {
					if ($('input[name="' + key + '"]').length > 0 && JSON_Obj[0].form2[key].length > 0 && sessionStorage.getItem('next') != 'true') {

						if ($(self).attr('type') != "radio") {
							$('input[name="' + key + '"]').val(JSON_Obj[0].form2[key]);
						}

						var stepNumber = parseInt(formsPBZ.getStep());
						$(".rstepwrapper").eq(stepNumber - 1).find('input[name="' + key + '"]').trigger("keyup");

						switch (key) {
							case "averageSalary":
								formsPBZ.setStep(1);
								formsPBZ.refreshStep(1);
								$('.rstepwrapper').addClass('rhide');
								$('.rstep1').removeClass('rhide');
								break;
							case "debitorIncomeOne":
								formsPBZ.setStep(2);
								formsPBZ.refreshStep(2);
								$('.rstepwrapper').addClass('rhide');
								$('.rstep2').removeClass('rhide');
								break;
							case "existingLoan":
								formsPBZ.setStep(3);
								formsPBZ.refreshStep(3);
								$('.rstepwrapper').addClass('rhide');
								$('.rstep3').removeClass('rhide');
								break;
							case "revolvingCard":
								formsPBZ.setStep(4);
								formsPBZ.refreshStep(4);
								$('.rstepwrapper').addClass('rhide');
								$('.rstep4').removeClass('rhide');
								break;
							case "overdraft":
								formsPBZ.setStep(5);
								formsPBZ.refreshStep(5);
								$('.rstepwrapper').addClass('rhide');
								$('.rstep5').removeClass('rhide');
								break;
							default:
						}
					}
				}
			}


			if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form3) {
				for (var key in JSON_Obj[0].form3) {
					if ($('input[name="' + key + '"]').length > 0 && JSON_Obj[0].form3[key].length > 0 && sessionStorage.getItem('next') != 'true') {

						if (key == "valueOfProperty") {
							formsPBZ.setStep(1);
							formsPBZ.refreshStep(1);
							$('.rstep1').removeClass('rhide');
						}
					}

					$('input[name="' + key + '"]').val(JSON_Obj[0].form3[key]).trigger('focus');
					$('input[name="' + key + '"]').val(JSON_Obj[0].form3[key]).trigger("keyup");

				}
			}
		}
	}


	function showStep(key_obj) {
		$('.rstepwrapper').addClass('rhide');

		if (key_obj.indexOf('One') > -1) {
			$('.rstep1').removeClass('rhide');
			formsPBZ.setStep(1);
			formsPBZ.refreshStep(1);
		}
		if (key_obj.indexOf('Two') > -1) {
			$('.rstep2').removeClass('rhide');
			formsPBZ.setStep(2);
			formsPBZ.refreshStep(2);
		}
		if (key_obj.indexOf('Three') > -1) {
			$('.rstep3').removeClass('rhide');
			formsPBZ.setStep(3);
			formsPBZ.refreshStep(3);
		}
		if (key_obj.indexOf('Four') > -1) {
			$('.rstep4').removeClass('rhide');
			formsPBZ.setStep(4);
			formsPBZ.refreshStep(4);
		}
		if (key_obj.indexOf('Five') > -1) {
			$('.rstep5').removeClass('rhide');
			formsPBZ.setStep(5);
			formsPBZ.refreshStep(5);
		}
	}


	this.goToNext = function () {
		$(document).on('click', 'button.r-btn-next', function (e) {
			
			formsPBZ.freeEmptyField();

			sessionStorage.removeItem('back');
			sessionStorage.removeItem('next');

			e.preventDefault();
			var self = $(this);
			var dataStepNew = parseInt(self.attr('data-step')) + 1;

			var myForm = $('input[name="myForm"]').val();

			sessionStorage.setItem('mortgageJSON', JSON.stringify(formsPBZ.sessionMortgage));

			if (myForm == 'form1') {
				sessionStorage.setItem('mortgageStep', '1');
			}
			if (myForm == 'form2') {
				sessionStorage.setItem('mortgageStep', '2');
			}
			if (myForm == 'form3') {
				sessionStorage.setItem('mortgageStep', '3');
			}

			if (dataStepNew > $("#numberofsteps").val()) {
				var myForm = $('input[name="myForm"]').val();

				/*var sessionStorageMortgage = sessionStorage.getItem('mortgageJSON');
				if (sessionStorageMortgage.length > 0) {
					var JSON_Obj = JSON.parse(sessionStorageMortgage);
				}

				if (myForm == 'form1') {
					if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form1) {
						for (var key in JSON_Obj[0].form1) {
							if (JSON_Obj[0].form1[key].length > 0) {
								$("form#formTemp").append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].form1[key] + '"/>');
							}
						}
					}
				}
				if (myForm == 'form2') {
					if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form1) {
						for (var key in JSON_Obj[0].form1) {
							if (JSON_Obj[0].form1[key].length > 0) {
								$("form#formTemp").append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].form1[key] + '"/>');
							}
						}
					}
					if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form2) {
						for (var key in JSON_Obj[0].form2) {
							if (JSON_Obj[0].form2[key].length > 0) {
								$("form#formTemp").append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].form2[key].replace(/[^0-9]/g, '').replace('&nbsp;', '') + '"/>');
							} else {
								$("form#formTemp").append('<input type="hidden" name="' + key + '" value="0"/>');
							}
						}
					}

				}
				if (myForm == 'form3') {
					if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form1) {
						for (var key in JSON_Obj[0].form1) {
							if (JSON_Obj[0].form1[key].length > 0) {
								$("form#formTemp").append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].form1[key] + '"/>');
							}
						}
					}
					if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form2) {
						for (var key in JSON_Obj[0].form2) {
							if (JSON_Obj[0].form2[key].length > 0) {
								$("form#formTemp").append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].form2[key].replace(/[^0-9]/g, '').replace('&nbsp;', '') + '"/>');
							} else {
								$("form#formTemp").append('<input type="hidden" name="' + key + '" value="0"/>');
							}
						}
					}
					if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form3) {
						for (var key in JSON_Obj[0].form3) {
							if (JSON_Obj[0].form3[key].length > 0) {
								$("form#formTemp").append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].form3[key].replace(/[^0-9]/g, '').replace('&nbsp;', '') + '"/>');
							} else {
								$("form#formTemp").append('<input type="hidden" name="' + key + '" value="0"/>');
							}
						}
					}
				}

				$('form#formTemp').submit();*/
				
				var sessionStorageMortage = sessionStorage.getItem('mortgageJSON') || "";
				if (sessionStorageMortage !== "") {
					if (sessionStorageMortage.length > 0) {
						var JSON_Obj = JSON.parse(sessionStorageMortage);
					}
				}

				if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form1) {
					for (var key in JSON_Obj[0].form1) {
						if (JSON_Obj[0].form1[key].length > 0) {
							$('form[name="formThanksMortgage"]').append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].form1[key].replace(String.fromCharCode(160), '') + '"/>');
						} else {
							$('form[name="formThanksMortgage"]').append('<input type="hidden" name="' + key + '" value=""/>');
						}
					}
				}
				if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form2) {
					for (var key in JSON_Obj[0].form2) {
						if (JSON_Obj[0].form2[key].length > 0) {
							$('form[name="formThanksMortgage"]').append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].form2[key].replace(String.fromCharCode(160), '') + '"/>');
						} else {
							$('form[name="formThanksMortgage"]').append('<input type="hidden" name="' + key + '" value=""/>');
						}
					}
				}
				if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form3) {
					for (var key in JSON_Obj[0].form3) {
						if (JSON_Obj[0].form3[key].length > 0) {
							$('form[name="formThanksMortgage"]').append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].form3[key].replace(String.fromCharCode(160), '') + '"/>');
						} else {
							$('form[name="formThanksMortgage"]').append('<input type="hidden" name="' + key + '" value=""/>');
						}
					}
				}
				
				if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].score) {
					$('form[name="formThanksMortgage"]').append('<input type="hidden" name="score" value="' + JSON_Obj[0].score + '"/>');
				}
				
				$('.leaveMessage__submit.j-privacy__btn.j-leaveMessage__submit.btn.btn-primary').attr('disabled', true);
				$('form[name="formThanksMortgage"]').submit();
				
			} else {
				formsPBZ.disableNext($('button.r-btn-next'));

				var myForm = $('input[name="myForm"]').val();

				if (myForm == 'form1') {

					//setTimeout(function () {

						if ($(".rstepwrapper").eq(dataStepNew - 1).find('input[data-ok]:checked').length > 0) {

							$(".rstepwrapper").eq(dataStepNew - 1).find('input[data-ok]:checked').parent('.rcontainer-input').trigger('click');

						} else {

							formsPBZ.disableNext(self);

						}

					//}, 100);

				}

				if (myForm == 'form2') {

					//setTimeout(function () {

						if ($(".rstepwrapper").eq(dataStepNew - 1).find('input').val().length > 0) {

							// if (dataStepNew - 1 == 1) {
							// 	for (var i = 0; i < mortgageForm["debitors"]; i++) {
							// 		$(".rstepwrapper").eq(dataStepNew - 1).find('.col-md-10')[i].classList.remove('rhide');
							// 	}
							// }
							
							var stepNum = parseInt(formsPBZ.getStep());
							var debitors_num = $(".rstepwrapper").eq(stepNum - 1).find('div[data-val]')[0];
							if(debitors_num && debitors_num != null && debitors_num != undefined){
								if(parseInt(debitors_num.innerText) >= 0){
									formsPBZ.setActiveNext($('button.r-btn-next'));
								}
							}

							$(".rstepwrapper").eq(dataStepNew - 1).find('input').each(function () {
								var self = $(this);
								if (self.is(':visible')) {
									self.trigger("keyup");
								}
							});
							
							$(".rstepwrapper").eq(dataStepNew - 1).find('input').each(function () {
								var self = $(this);
								if (self.is(':checked')) {
									//self.trigger("click");
									formsPBZ.setActiveNext($('button.r-btn-next'));
								}
							});

						} else {

							formsPBZ.disableNext($('button.r-btn-next'));
						}

					//}, 100);

				}
				
				var step = formsPBZ.getStep();
				var dataStepNew2 = parseInt(step);
				if ($(".rstepwrapper").eq(dataStepNew2 - 1).find('input[data-ok]:checked').hasClass("not_eligible")) {
					window.location.replace($("#submit").attr("data-redirect-not-eligible"));
				}
				else{
					formsPBZ.refreshStep(dataStepNew);
					formsPBZ.setStep(dataStepNew);

					$('.rstepwrapper').addClass('rhide');
					$('.rstepwrapper').eq(dataStepNew - 1).removeClass('rhide');
				}
				
				/*if ($(".rstepwrapper").eq(dataStepNew - 2).find('input[data-ok]:checked').hasClass("not_eligible")) {
					window.location.replace($("#submit").attr("data-redirect-not-eligible"));
				}*/
				
			}
			
			//formsPBZ.writeInput();
			// formsPBZ.checkMobileOrDesktopQuestionOne();

			formsPBZ.scrollToTop();
			
			var step = parseInt(formsPBZ.getStep());
			formsPBZ.setNextActiveCheckingFields(step);
			formsPBZ.scoreFunction();

			//Stores data inside input
			//$("[data-showhideloan]").find("input").val("");
			
			if ($(".rstepwrapper").eq(dataStepNew - 2).find('input[data-ok]:checked:visible').hasClass("not_eligible")) {
				window.location.replace($("#submit").attr("data-redirect-not-eligible"));
			}
			else{
				if (dataStepNew > $("#numberofsteps").val()) {
					sessionStorage.setItem('next', "true");
					
					var myForm = $('input[name="myForm"]').val();
					
					// TODO: capire come prendere il valore da controllare
					if (myForm == 'form2' && formsPBZ.sessionMortgage[0].form1.mortgage == 'WITHOUT_MORTGAGE') {
						window.location.replace($("#submit").attr("data-redirect-contact"));
					}
					else{
						window.location.replace($("#submit").attr("data-redirect"));
					}
				}
			}
		});
	};

	//scroll to top
	this.scrollToTop = function () {
		 $('.r-component-wrapper')[0].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
	}

	//if ($(".r-form-top-section").length > 0) {
	//	formsPBZ.scrollToTop();
	//}

	this.goBackStep = function () {
		$(document).on('click', 'button.r-btn-back', function (e) {
			
			formsPBZ.freeEmptyField();

			sessionStorage.removeItem('next');
			sessionStorage.removeItem('back');
			
			e.preventDefault();
			var self = $(this);
			var dataStepNew = parseInt(self.attr('data-step')) - 1;
			var myForm = $('input[name="myForm"]').val();
			
			sessionStorage.setItem('mortgageJSON', JSON.stringify(formsPBZ.sessionMortgage));

			if (dataStepNew < 1) {
				var gotoform = "";
				var mortgageForm = sessionStorage.getItem('mortgageForm') || "";
				/*if (mortgageForm !== "") {
					mortgageForm = JSON.parse(mortgageForm);

					//if (myForm == 'form1') { gotoform = mortgageForm.form1 }
					if (myForm == 'form1') { gotoform = mortgageForm.landing }
					if (myForm == 'form2') { gotoform = mortgageForm.form1 }
					if (myForm == 'form3') { gotoform = mortgageForm.form2 }

					if (gotoform !== "") {
						sessionStorage.setItem('back', "true");
						window.location.href = gotoform;
					}
				}*/
				if (myForm !== 'form1') {
					sessionStorage.setItem('back', "true");
					window.location.replace($("#previous").attr("data-redirect-previous-step"));
				}
				else{
					var loanPage = sessionStorage.getItem('calc');
					window.location.replace(loanPage);
				}
				
				//history.back(1);
			} else {

				formsPBZ.disableNext($('button.r-btn-next'));

				if (myForm == 'form1') {
					setTimeout(function () {
						if ($(".rstepwrapper").eq(dataStepNew - 1).find('input[data-ok]:checked').length > 0) {
							$(".rstepwrapper").eq(dataStepNew - 1).find('input[data-ok]:checked').parent('.rcontainer-input').trigger('click');
						} else {
							formsPBZ.disableNext($('button.r-btn-next'));
						}
					}, 100);
				}

				if (myForm == 'form2') {

					setTimeout(function () {
						if ($(".rstepwrapper").eq(dataStepNew - 1).find('input').val().length > 0) {
							var mortgageForm = JSON.parse(sessionStorage.getItem('mortgageJSON'))[0].form2
							
							var stepNum = parseInt(formsPBZ.getStep());
							var debitors_num = $(".rstepwrapper").eq(stepNum - 1).find('div[data-val]')[0];
							if(debitors_num && debitors_num != null && debitors_num != undefined){
								if(parseInt(debitors_num.innerText) >= 0){
									formsPBZ.setActiveNext($('button.r-btn-next'));
								}
							}

							// controllo sui radio per attivare il bottone
							$(".rstepwrapper").eq(dataStepNew - 1).find('input').each(function () {
								var self = $(this);
								if (self.is(':checked')) {
									formsPBZ.setActiveNext($('button.r-btn-next'));
								}
							});

							$(".rstepwrapper").eq(dataStepNew - 1).find('input').each(function () {
								var self = $(this);
								if (self.is(':visible')) {
									self.trigger("keyup");
								}
							});

						} else {
							formsPBZ.setActiveNext($('button.r-btn-next'));
						}
					}, 100);
				}

				formsPBZ.refreshStep(dataStepNew);
				formsPBZ.setStep(dataStepNew);

				$('.rstepwrapper').addClass('rhide');
				$('.rstepwrapper').eq(dataStepNew - 1).removeClass('rhide');

			}
			
			// formsPBZ.checkMobileOrDesktopQuestionOne();

			formsPBZ.scrollToTop();
			
			//formsPBZ.writeInput();

			//Stores data inside input
			//$("[data-showhideloan]").find("input").val("");
		});
	}

	this.formStep1Mortagage = function () {
		formsPBZ.setStep(1);
	}

	//set active input
	this.setActiveInput = function () {
		$(".rcontainer-input").on("click", function () {
			var name = $(this).find('input').attr("name");
			$('[name=' + name + ']').parent().removeClass("active");
			$(this).addClass("active");

			var myForm = $('input[name="myForm"]').val();

			if (myForm == 'form1') {
				var stepNumber = parseInt(formsPBZ.getStep());
				var chekToInput = $(".rstepwrapper").eq(stepNumber - 1).find("input[data-ok][name=" + name + "]").is(":checked");
				if (chekToInput) formsPBZ.sessionMortgage[0].form1[name] = $('[name=' + name + ']:checked').val();
			}

			if (myForm == 'form2') {
				var stepNumber = parseInt(formsPBZ.getStep());
				var chekToInput = $(".rstepwrapper").eq(stepNumber - 1).find("input[data-ok][name=" + name + "]").is(":checked");
				formsPBZ.sessionMortgage[0].form2[name] = $('[name=' + name + ']:checked').val();
			}

			if (myForm == 'form3') {
				var stepNumber = parseInt(formsPBZ.getStep());
				var chekToInput = $(".rstepwrapper").eq(stepNumber - 1).find("input[data-ok][name=" + name + "]").is(":checked");
				formsPBZ.sessionMortgage[0].form3[name] = $('[name=' + name + ']:checked').val();
			}

			
			var step = parseInt(formsPBZ.getStep());
			formsPBZ.setNextActiveCheckingFields(step);
			//formsPBZ.showError(formsPBZ.getStep());
		});

	}

	this.setActiveImport = function () {
		$(".rcontainer-import input").on("keyup", function () {
			var self = $(this);
			if (self.val().length > 0) {

				// if ((self.attr("name") == "babyLoan") || (self.attr("name") == "cashLoan")) {
				// 	if (($("[name=cashLoan]").val().length > 0) && ($("[name=babyLoan]").val().length > 0)) {
				// 		formsPBZ.setActiveNext($('button.r-btn-next'));
				// 	} else {
				// 		formsPBZ.disableNext($('button.r-btn-next'));
				// 	}
				// } 
				formsPBZ.setActiveNext($('button.r-btn-next'));


				if ($(".rstepwrapper").eq(parseInt(formsPBZ.getStep()) - 1).find("input").length > 1 && $(".rstepwrapper").eq(parseInt(formsPBZ.getStep()) - 1).find('.rcontainer-import').attr('data-showhideloan') == undefined) {
					$(".rstepwrapper").eq(parseInt(formsPBZ.getStep()) - 1).find("input").each(function () {
						if ($(this).is(':visible') && $(this).val() == '') {
							formsPBZ.disableNext($('button.r-btn-next'));
							return;
						}
					});
				}

				var name = $(this).attr("name");
				var myForm = $('input[name="myForm"]').val();

				if (myForm == 'form2') {
					// Potrebbe servirci da controllare all'invio della mail
					if (isCIB) {
						formsPBZ.sessionMortgage[0].form2[name] = $('[name=' + name + ']').val().replace(/ /g, '');
					} else {

						if ($('[name=' + name + ']').attr('type') != "radio" && $('[name=' + name + ']').length > 1) {
							for (var i = 0; i < $('[name=' + name + ']').length; i++) {
								if ($($('[name=' + name + ']')[i]).val() != "") {
									formsPBZ.sessionMortgage[0].form2[name] = $($('[name=' + name + ']')[i]).val().replace(/ /g, '');
								}
							}
						} else {
							formsPBZ.sessionMortgage[0].form2[name] = $('[name=' + name + ']').val().replace(/ /g, '');
						}
					}
				}

				if (myForm == 'form3') {
					if ($('[name=' + name + ']').length > 1) {
						for (var i = 0; i < $('[name=' + name + ']').length; i++) {
							if ($($('[name=' + name + ']')[i]).val() != "") {
								formsPBZ.sessionMortgage[0].form3[name] = $($('[name=' + name + ']')[i]).val().replace(/ /g, '');
							}
						}
					} else {
						formsPBZ.sessionMortgage[0].form3[name] = $('[name=' + name + ']').val().replace(/ /g, '');
					}
				}
			} else {
				formsPBZ.disableNext($('button.r-btn-next'));
			}
		});
	}

	//refresh the step progress
	this.refreshStep = function (step) {
		var myForm = $('input[name="myForm"]').val();
		totalSteps = 12;

		if (myForm == 'form2') {
			step += 6;
		}

		if (myForm == 'form3') {
			step += 11;
		}

		if ((step !== null) && (step !== "") && (step !== undefined)) {
			$(".r-cur-step").text(step);
			if ((totalSteps !== null) && (totalSteps !== "") && (totalSteps !== undefined)) {
				$(".r-tot-step").text(totalSteps);
				$(".r-progress-bar-fill").width(parseInt(step) / parseInt(totalSteps) * 100 + "%");
			}
		}
		formsPBZ.scrollToTop();
	}

	//set button next active
	this.setActiveNext = function (thisBtn) {
		thisBtn.addClass("active").prop("disabled", false);
	}

	//disable button next
	this.disableNext = function (thisBtn) {
		thisBtn.removeClass("active").prop("disabled", true);
	}

	//get the current step number
	this.getStep = function () {
		var stepNumber = $('button.r-btn-next').attr('data-step');
		return stepNumber;
	}

	//show the error msg
	this.showError = function (stepNumber) {
		stepNumber = parseInt(stepNumber);
		var curstepwrapper = $(".rstepwrapper").eq(stepNumber - 1).find("input[data-ok]").is(":checked") || false;
		if (curstepwrapper || curstepwrapper == "true") {
			$(".rstepwrapper").eq(stepNumber - 1).find(".rerror-choice").addClass('rhide'); //hide the error
			formsPBZ.setActiveNext($('button.r-btn-next'));
		} else {
			$(".rstepwrapper").eq(stepNumber - 1).find(".rerror-choice").removeClass('rhide'); //show the error
			formsPBZ.disableNext($('button.r-btn-next'));
		}

	}

	//set the current step number
	this.setStep = function (stepNumber) {
		$(".r-form-submit-wrapper button").attr("data-step", stepNumber);
		formsPBZ.refreshStep(stepNumber);
	}

	//toggle form accordion
	this.toggleAccordion = function () {

		$('[data-accordion="title"]').on("click", function () {

			$(this).addClass("rhide");
			$(this).next('[data-accordion="detail"]').removeClass("rhide");

		});

		$('[data-accordion="detail"] .rtitle-accordotion').on("click", function () {

			$(this).parent().addClass("rhide");
			$(this).parent().prev('[data-accordion="title"]').removeClass("rhide");

		});

	}

	//plus minus
	this.plusMinus = function (val) {

		if ($("[data-plusminus]").length > 0) {

			$("[data-plusminus]").each(function (index, elem) {

				if ((val !== null) && (val !== undefined) && (val !== "")) {
					$(elem).find("[data-val]").text(val);
				}

				var thisMax = $(elem).attr("data-maximum");

				var curVal = $(elem).find("[data-val]").text();
				var thisMinus = $(elem).find("[data-minus]");
				var thisPlus = $(elem).find("[data-plus]");


				thisMinus.removeClass("disabled");
				thisPlus.removeClass("disabled");
				if (curVal == "0") {
					thisMinus.addClass("disabled");
				}

				if (curVal == thisMax) {
					thisPlus.addClass("disabled");
				}

			});
		}
	}

	/*$("[data-landing]").on("click", function () {
		var mortgageFormOBJ = JSON.parse(sessionStorage.getItem('mortgageForm'));
		//if (!isCIB) {
		if (mortgageFormOBJ.length > 0) {
			mortgageFormOBJ.landing = window.location.pathname;
		}
		sessionStorage.setItem('next', "true");
		//}

		// TODO: da ricontrollare e testare
		if (mortgageFormOBJ != undefined) {
			mortgageFormJSON = JSON.stringify(mortgageFormOBJ);
			sessionStorage.setItem('mortgageForm', mortgageFormJSON);
		}
	})*/

	
	//Open form mortgage
	$("[data-openmortgageform]").on("click", function () {

		formsPBZ.getInputs();

		var calcLnk = window.location.pathname;
		sessionStorage.setItem('calc', calcLnk);

	});
	
	
	$(".loanLink").click(function () {
		var loanLnk = sessionStorage.getItem('calc');
	    this['href'] = loanLnk;
	})

	//get inputs for the form
	this.getInputs = function () {

		// TODO: IMPORTANTE da cambiare nome al calcolatore da cui vengono i dati 

		/*if ($('[data-active-tab="withsalary"]').hasClass("open")) { //if is promo

			var installment = "" + window.intesa.loan_calculator_ispslovenia.firstMonthlyInstallment || "";
			var interestRate = "" + window.intesa.loan_calculator_ispslovenia.firstInterestRate || "";

		} else {

			var installment = "" + window.intesa.loan_calculator_ispslovenia.firstMonthlyInstallment || "";
			var interestRate = "" + window.intesa.loan_calculator_ispslovenia.firstInterestRate || "";

		}*/


		var tenor = "" + window.intesa.loan_calculator_pbz.tenor || "";
		var tenorUnit = "" + window.intesa.loan_calculator_pbz.tenorUnit || "";
		var loanAmount = "" + window.intesa.loan_calculator_pbz.loanAmount || "";
		var interestRate = "" + window.intesa.loan_calculator_pbz.interestRateType || "";
		var firstInterestRate = "" + window.intesa.loan_calculator_pbz.firstInterestRate || "";
		var installment = "" + window.intesa.loan_calculator_pbz.firstMonthlyInstallment || "";
		var mortgage = "" + window.intesa.loan_calculator_pbz.activeMortgage.variantType || "";
		var amountToRepay = "" + window.intesa.loan_calculator_pbz.amountToRepay || "";
		var currency = "" + window.intesa.loan_calculator_pbz.currency || "";
		
		var productName = $("[name=fProductName]").val() || "";
		var productId = $("[name=fProductId]").val() || "";
		var interestPeriod = $("[name=fInterestPeriod]").val() || "";
		var loanPurpose = $("[name=fLoanPurpose]").val() || "";
		var personalLoanConfiguration = JSON.parse($("[name=personalLoanConfiguration]").val()) || "";


		formsPBZ.sessionMortgage[0].form1.loanAmount = loanAmount || '';
		formsPBZ.sessionMortgage[0].form1.tenor = tenor || '';
		formsPBZ.sessionMortgage[0].form1.interestRate = interestRate || '';
		formsPBZ.sessionMortgage[0].form1.installment = installment || '';
		formsPBZ.sessionMortgage[0].form1.mortgage = mortgage || '';
		formsPBZ.sessionMortgage[0].form1.amountToRepay = amountToRepay || '';
		formsPBZ.sessionMortgage[0].form1.currency = currency || '';
		formsPBZ.sessionMortgage[0].form1.firstInterestRate = firstInterestRate || '';
		formsPBZ.sessionMortgage[0].form1.tenorUnit = tenorUnit || '';
		
		formsPBZ.sessionMortgage[0].form1.productId = productId || '';
		formsPBZ.sessionMortgage[0].form1.productName = productName || '';
		formsPBZ.sessionMortgage[0].form1.interestPeriod = interestPeriod || '';
		formsPBZ.sessionMortgage[0].form1.loanPurpose = loanPurpose || '';
		formsPBZ.sessionMortgage[0].form1.personalLoanConfiguration = personalLoanConfiguration || '';

		sessionStorage.setItem('mortgageJSON', JSON.stringify(formsPBZ.sessionMortgage));

	}

	//show hide elements
	this.showHideElements = function (val) {

		if ((val !== null) && (val !== undefined) && (val !== "")) {

			var stepNumber = formsPBZ.getStep();
			var curstepwrapper = $(".rstepwrapper").eq(stepNumber - 1);
			curstepwrapper.find(".mod-hom1").addClass("rhide");
			val = parseInt(val);

			for (i = 0; i <= val - 1; i++) {
				curstepwrapper.find(".mod-hom1").eq(i).removeClass("rhide");
			}

			if (val > 0) formsPBZ.setActiveNext($('button.r-btn-next'));
			if ($(".rstepwrapper").eq(parseInt(formsPBZ.getStep()) - 1).find("input").length > 1) {
				$(".rstepwrapper").eq(parseInt(formsPBZ.getStep()) - 1).find("input").each(function () {
					if (($(this).is(':visible') && $(this).val() == '')) {

						if (!isCIB && formsPBZ.getStep() == 2) {
							formsPBZ.setActiveNext($('button.r-bth-next'));
						}
						formsPBZ.disableNext($('button.r-btn-next'));
						return;
					}
				});
			}
		}

	}

	/*this.resetForms2 = function (thisVal) {
		if (parseInt(thisVal) - 1 == 0) {
			$('input[name="debitorIncomeOne"]').val('');
			formsPBZ.sessionMortgage[0].form2.debitorIncomeOne = "";
		}
		if (parseInt(thisVal) - 1 == 1) {
			$('input[name="debitorIncomeTwo"]').val('');
			formsPBZ.sessionMortgage[0].form2.debitorIncomeTwo = "";
		}
	}*/

	//decrease Value
	$("[data-minus]").on("click", function () {
		var thisCounter = $(this).next("[data-val]");
		var thisVal = thisCounter.text();
		if (!$(this).hasClass("disabled")) {
			thisCounter.text(parseInt(thisVal) - 1);
			formsPBZ.sessionMortgage[0].form2['debitors'] = String(parseInt(thisVal) - 1);
			formsPBZ.plusMinus();

			formsPBZ.showHideElements(parseInt(thisVal) - 1);

			/*if ($('input[name="debitorIncomeOne"]').length > 0) {
				formsPBZ.resetForms2(thisVal);
			}*/
		}
		
		var step = parseInt(formsPBZ.getStep());
		formsPBZ.setNextActiveCheckingFields(step);
	});


	var elem = $('.rcontainer-import')
	//show/hide loan form2
	$("[data-showloan]").on("click", function () {
		$(this).parents(".rstepwrapper").find("[data-showhideloan]").removeClass("rhide");
		
		var step = parseInt(formsPBZ.getStep());
		formsPBZ.setNextActiveCheckingFields(step);
	});
	$("[data-hideloan]").on("click", function () {
		$(this).parents(".rstepwrapper").find("[data-showhideloan]").addClass("rhide").find("input"); //.val("")
		if (myForm == 'form2') {
			var self = $(this);
			var dataStepNew = parseInt(self.attr('data-step')) - 1;
			var insertedValueName = $(".rstepwrapper").eq(dataStepNew - 1).find('input[data-format-currency').attr('name');
			$(".rstepwrapper").eq(dataStepNew - 1).find('input[name="' + insertedValueName + '"]').trigger("keyup");
			var mortgageForm = JSON.parse(sessionStorage.getItem('mortgageJSON') || "")[0].form2;
		}
		
		var step = parseInt(formsPBZ.getStep());
		formsPBZ.setNextActiveCheckingFields(step);
	});

	//increase Value
	$("[data-plus]").on("click", function () {

		var thisCounter = $(this).prev("[data-val]");
		var thisVal = thisCounter.text();
		if (!$(this).hasClass("disabled")) {
			thisCounter.text(parseInt(thisVal) + 1);
			formsPBZ.sessionMortgage[0].form2['debitors'] = String(parseInt(thisVal) + 1);
			
			formsPBZ.plusMinus();

			formsPBZ.showHideElements(parseInt(thisVal) + 1);

			if (isCIB) {
				if (parseInt(thisVal) + 1 == 1) {
					$('input[name="debitorIncomeOne"]').trigger('keyup');
				}
				if (parseInt(thisVal) + 1 == 2) {
					$('input[name="debitorIncomeTwo"]').trigger('keyup');
				}
				if (parseInt(thisVal) + 1 == 3) {
					$('input[name="debitorIncomeThree"]').trigger('keyup');
				}
				if (parseInt(thisVal) + 1 == 4) {
					$('input[name="debitorIncomeFour"]').trigger('keyup');
				}
			}
		}
		
		var step = parseInt(formsPBZ.getStep());
		formsPBZ.setNextActiveCheckingFields(step);
	});

	//set selected label as active
	$(".r-thankyou-time label").on("click", function () {
		$(".r-thankyou-time label").removeClass("active");
		$(this).addClass("active");
	});

	//accept only numbers
	$(document).on("input", ".r-thankyou-wrapper [name='prefixNumber'], .r-thankyou-wrapper [name='phoneNumber']", function (e) {
		$(this).val($(this).val().replace(/[^0-9]/g, ''));//allow only numbers
	});

	//check success form privacy status
	this.checkPrivacy = function () {
		var item_thanksName = "none";
		if ($("#item_thanksName").length > 0) {
			item_thanksName = $("#item_thanksName").val();
		}
		var thanksLastname = "none";
		if ($("#item_thanksLastname").length > 0) {
			thanksLastname = $("#item_thanksLastname").val();
		}
		var checkCaptcha = $("input[name='recaptchaKey']").length >= 1 || "" != $(".g-recaptcha-response").val() ? true : false;
		const re = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
		const reName = /^[a-zA-ZÁÉÚŰŐÓÜÖÍáéúűőóüöíčćšžđČĆŠŽĐ \- \\s.]*$/;
		if (($("#privacystatus").is(":checked")) && ($("#item_email").val() !== "") && (re.test($("#item_email").val())) 
				&& (item_thanksName !== "") && (thanksLastname !== "") && (reName.test(item_thanksName)) && (reName.test(thanksLastname))
			&& ($('[name="prefixNumber"]').val() !== "") && ($('[name="phoneNumber"]').val() !== "") && ($('[name="phoneNumber"]').val().length == 9)
			&& (checkCaptcha)) {
			$(".r-thankyou-wrapper .j-privacy__btn").prop("disabled", false);
		} else {
			$(".r-thankyou-wrapper .j-privacy__btn").prop("disabled", true);
		}
	}


	//change btn status after privacy changes
	$("#privacystatus").on("click", function () {

		formsPBZ.checkPrivacy();

	});

	$(".r-thankyou-wrapper input").on("change input", function (e) {
		formsPBZ.checkPrivacy();
	});

	//validate on focus out
	$('.r-thankyou-content input[required]').on("focusout blur", function () {
		$(this).parsley().validate();
	});


	//submit form success
	$(".r-thankyou-wrapper .j-privacy__btn").on("click", function (e) {

		e.preventDefault();

		//check parsley first
		var isformok = $('form[name="formThanksMortgage"]').parsley().validate();
		if (isformok) {

			// get all the inputs into an array.
			var $inputs = $('.r-thankyou-content :input');

			$inputs.each(function () {

				if ($(this).attr('name') !== undefined) {

					var vall = $(this).val() || "";
					var namee = $(this).attr('name') || "";

					if (namee == "privacystatus") {
						if ($(this).is(":checked")) {
							vall = "true";
						} else {
							vall = "false";
						}
					}

					if (namee == "radioTime") {
						if ($(this).is(":checked")) {
							$("form#formTemp").find("input[name=" + $(this).attr('name') + "]").remove();
							$("form#formTemp").append('<input type="hidden" name="' + $(this).attr('name') + '" value="' + vall + '"/>');
						} else {
							//
						}
						//
					} else {
						$("form#formTemp").find("input[name=" + $(this).attr('name') + "]").remove();
						$("form#formTemp").append('<input type="hidden" name="' + $(this).attr('name') + '" value="' + vall + '"/>');
					}

				}


			});

			// FIXME: da vede quale dei due tenere
			/*var sessionStorageMortgage = sessionStorage.getItem('mortgageJSON') || "";
			if (sessionStorageMortgage !== "") {
				if (sessionStorageMortgage.length > 0) {
					var JSON_Obj = JSON.parse(sessionStorageMortgage);
				}
			}

			if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form1) {
				for (var key in JSON_Obj[0].form1) {
					if (JSON_Obj[0].form1[key].length > 0) {
						$("form#formTemp").append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].form1[key] + '"/>');
					}
				}
			}
			if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form2) {
				for (var key in JSON_Obj[0].form2) {
					if (JSON_Obj[0].form2[key].length > 0) {
						$("form#formTemp").append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].form2[key].replace(/[^0-9]/g, '').replace('&nbsp;', '') + '"/>');
					} else {
						$("form#formTemp").append('<input type="hidden" name="' + key + '" value="0"/>');
					}
				}
			}
			if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form3) {
				for (var key in JSON_Obj[0].form3) {
					if (JSON_Obj[0].form3[key].length > 0) {
						$("form#formTemp").append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].form3[key].replace(/[^0-9]/g, '').replace('&nbsp;', '') + '"/>');
					} else {
						$("form#formTemp").append('<input type="hidden" name="' + key + '" value="0"/>');
					}
				}
			}

			$('form#formTemp').submit();*/
			
			var sessionStorageMortage = sessionStorage.getItem('mortgageJSON') || "";
			if (sessionStorageMortage !== "") {
				if (sessionStorageMortage.length > 0) {
					var JSON_Obj = JSON.parse(sessionStorageMortage);
				}
			}

			if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form1) {
				for (var key in JSON_Obj[0].form1) {
					if (JSON_Obj[0].form1[key].length > 0 && key != "personalLoanConfiguration" ) {
						$('form[name="formThanksMortgage"]').append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].form1[key].replace(String.fromCharCode(160), '') + '"/>');
					} else {
						if(key != "personalLoanConfiguration"){
							$('form[name="formThanksMortgage"]').append('<input type="hidden" name="' + key + '" value=""/>');
						}
					}
				}
				if(JSON_Obj[0].form1.personalLoanConfiguration != undefined){
					$('form[name="formThanksMortgage"]').append('<input type="hidden" name="personalLoanConfiguration" value=""/>');
					$('form[name="formThanksMortgage"] input[name="personalLoanConfiguration"]').val(JSON.stringify(JSON_Obj[0].form1.personalLoanConfiguration).toString());
				}
			}
			if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form2) {
				for (var key in JSON_Obj[0].form2) {
					if (JSON_Obj[0].form2[key].length > 0) {
						$('form[name="formThanksMortgage"]').append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].form2[key].replace(String.fromCharCode(160), '') + '"/>');
					} else {
						$('form[name="formThanksMortgage"]').append('<input type="hidden" name="' + key + '" value=""/>');
					}
				}
			}
			if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].form3) {
				for (var key in JSON_Obj[0].form3) {
					if (JSON_Obj[0].form3[key].length > 0) {
						$('form[name="formThanksMortgage"]').append('<input type="hidden" name="' + key + '" value="' + JSON_Obj[0].form3[key].replace(String.fromCharCode(160), '') + '"/>');
					} else {
						$('form[name="formThanksMortgage"]').append('<input type="hidden" name="' + key + '" value=""/>');
					}
				}
			}
			
			if (JSON_Obj && JSON_Obj[0] && JSON_Obj[0].score) {
				var scoreSum = JSON_Obj[0].score;
				var priority = "";
				if(scoreSum <= 3){
					priority = 'Low Priority (' + scoreSum + '/6)'; 
				}
				if(scoreSum > 3 && scoreSum <= 5){
					priority = 'Medium Priority (' + scoreSum + '/6)'; 
				}
				if(scoreSum >= 6){
					priority = 'High Priority (' + scoreSum + '/6)'; 
				}
				
				$('form[name="formThanksMortgage"]').append('<input type="hidden" name="score" value="' + priority + '"/>');
			}
			
			// var linkThisPage = window.location.href;
			
			// $('form[name="formThanksMortgage"]').append('<input type="hidden" name="sourceUrl" value="' + linkThisPage + '"/>');
			
			$('.leaveMessage__submit.j-privacy__btn.j-leaveMessage__submit.btn.btn-primary').attr('disabled', true);
			$('form[name="formThanksMortgage"]').submit();

		}
		
		//window.location.replace($("#submitMortgage").attr("data-redirect"));

		return false;


	});

	//delete sessionstorage if form is successfully sent
	if ($("[data-formsent]").length > 0) {
		sessionStorage.removeItem('mortgageJSON');
		sessionStorage.removeItem('mortgageStep');
	}

	//on resize, reset the wallpaper
	function resizedw() {
		if ($("[data-bgimg]").length > 0) {
			$("[data-bgimg]").each(function () {
				var imageUrl = $(this).attr("data-bgimg");
				$(this).css('background-image', 'url(' + imageUrl + ')');
			});
		}
	}

	var doit;
	window.onresize = function () {
		clearTimeout(doit);
		doit = setTimeout(resizedw, 10);
	};

	//replace placeholder in mortgage title
	var sessionStorageMortgage = sessionStorage.getItem('mortgageJSON') || "";
	if (sessionStorageMortgage.length > 0) {
		var JSON_Obj = JSON.parse(sessionStorageMortgage);
		var placeholder = JSON_Obj[0].form1["productName"] || "";
		if ($(".r-title").length > 0) {
			$(".r-title").each(function () {
				var thistitle = $(this).html();
				thistitle = thistitle.replace("${productName}", placeholder);
				$(this).html(thistitle);
			})
		}
	}

	/**
	 * Call to servlet
	 *
	 * @param {*} url
	 * @param {*} form
	 */
	this.callServlet = function (url, form) {

		$.ajax({

			type: "POST",
			data: form.serialize(),
			url: url,
			success: function (data) {

				console.log("success sending form");

			},
			error: function (data) {

				console.log("error sending form");

			}

		});

	};


	/**
	 * Show modal
	 *
	 */
	/*
	this.showModal = function () {

		if ($("[data-show-modal]").length) {

			$("[data-show-modal]").each(function (index, el) {

				if ($(this).attr("data-show-modal") == "true") {

					var modalName = $(this).attr("id");
					$("[data-target='#" + modalName + "']").trigger('click');

				}

			});

		}

	};
	*/
	
	$(document).ready(function() {
		var check = $("#landing-button-mortgage").length > 0;
		if (check){
		    console.log("inner mortgage");
		    setTimeout(function() {
		    $("#landing-button-mortgage").removeClass("disabled");
		    },1000);
		}
	});

};



/**
 * Get class instance
 *
 */
Intesa.FormsPBZ.getInstance = function () {

	if (!window.intesa) {

		window.intesa = new Object();

	}
	if (!window.intesa.formsPBZ) {

		window.intesa.formsPBZ = new Intesa.FormsPBZ();

	}

	return window.intesa.formsPBZ;

};
      /**
* On DOM ready
*
*/
      // $( document ).ready( function() {
/* document.addEventListener( "DOMContentLoaded", function() {
 
	// init component
	var formsPBZ = Intesa.formsPBZ.getInstance();
	formsPBZ.init();
 
} ); */
